module.exports = (
  $timeout,
) ->
  FORWARD  = 1
  BACKWARD = -1

  afterRender = $timeout

  getAllTabTargets = () ->
    $( '[dynamic-tab-target]' )

  getElementTargetController = ( element ) ->
    angular.element( element ).controller( 'dynamicTabTarget' )

  getActiveTabTargets = () ->
    getAllTabTargets().filter ( index, element ) ->
      getElementTargetController( element ).isActive()

  getElementIndex = ( element, elements ) ->
    $.inArray( element[0], elements )

  leave = ( element ) ->
    getElementTargetController( element[0] ).leave()

  focus = ( element ) ->
    getElementTargetController( element[0] ).focus()

  # Takes a number and puts it in the rage of 0..count-1.
  cyclify = ( index, count ) ->
    # We add count to index in order to handle negative numbers
    ( index + count ) % count

  tab = ( fromElement, delta ) ->
    afterRender ->
      activeTabTargets = getActiveTabTargets()
      targetCount       = activeTabTargets.length
      fromIndex         = getElementIndex( fromElement, activeTabTargets )

      if fromIndex != -1
        nextIndex   = cyclify( fromIndex + delta, targetCount )
        nextElement = activeTabTargets.eq( nextIndex )
        leave( fromElement )
        focus( nextElement )

  new class DynamicTabManager

    tabForward: ( fromElement ) ->
      tab( fromElement, FORWARD )

    tabBackward: ( fromElement ) ->
      tab( fromElement, BACKWARD )
